import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'zsd-selfhelp',
  templateUrl: '../view/selfhelp.component.html',
})
export class SelfHelpComponent implements OnInit {
  isFilterOpen: boolean;
  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  openFilter() {
    this.isFilterOpen = true;
    $('#knowledgebase_filterpanel_control').width('100%');
    $('body').css('overflow-y', 'hidden');
  }

}
